import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BackdropLoader, Icon } from '@livable/saas-react-components';
import { Accordion, AccordionSummary, Typography, AccordionDetails, Button, Paper } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { UTILITIES_STATUSES } from 'src/constants/utilities';
import { useStore } from 'src/stores';
import { completedSteps } from 'src/utils/allocations';
import AllocationCounter from '../AllocationCounter';
import AllocationProgressBar from '../AllocationProgressBar';
import AllocationProgressTable from '../AllocationProgressTable';
import useStyles from '../styles';
import { toJS } from 'mobx';
export function BillsProgress(_ref) {
  let cycle = _ref.cycle,
    fromHistory = _ref.fromHistory,
    hideStatement = _ref.hideStatement,
    selectedBuilding = _ref.selectedBuilding,
    title = _ref.title,
    utilities = _ref.utilities;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  let availables = Object.keys(UTILITIES_STATUSES);
  if (hideStatement) availables = availables.filter(s => s !== 'TableReadyStatementSent');else if (fromHistory) availables = availables.filter(s => s === 'TableReadyStatementSent' || s === 'TableSkipped');
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFetched = _useState6[0],
    setIsFetched = _useState6[1];
  const _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    complSteps = _useState8[0],
    setCompletedSteps = _useState8[1];
  const _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    propertyUtilites = _useState0[0],
    setPropertyUtilites = _useState0[1];
  const _useState1 = useState({}),
    _useState10 = _slicedToArray(_useState1, 2),
    statuses = _useState10[0],
    setStatuses = _useState10[1];
  const getBillsAllocations = async data => {
    const resp = await store.allocations.getBillsAsync.run(data);
    return resp;
  };
  const getUtilityInfo = async ids => {
    if (!store.account.featureFlagsStore.getIsBillAutomationEnabled || !store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
      const resp = await store.utilityProviders.getUtilityInfoAsync.run({
        utilityIds: ids
      });
      return resp;
    } else {
      const resp = await store.utilityProviders.getPropertyUtilityInfoAsync.run({
        utilityIds: ids,
        propertyId: selectedBuilding
      });
      return resp;
    }
  };
  useEffect(() => {
    if (!isFetched && isOpen && isLoading) {
      getBillsAllocations({
        allocationCycleId: cycle.id,
        propertyIds: [selectedBuilding]
      }).then(() => {
        const propUtilites = store.allocations.billAllocationsList.get(selectedBuilding) ? [...toJS(store.allocations.billAllocationsList.get(selectedBuilding))] : [];
        const utilityIds = propUtilites.map(utility => utility.utilityId);
        return getUtilityInfo(utilityIds);
      }).then(async () => {
        const propUtilites = store.allocations.billAllocationsList.get(selectedBuilding) ? [...store.allocations.billAllocationsList.get(selectedBuilding).map(utility => {
          var _store$utilityProvide;
          const utilityAllocation = utilities.find(u => u.utilityId === utility.utilityId);
          return {
            allocation: utility,
            utilityId: fromHistory ? utility.utilityId : utilityAllocation === null || utilityAllocation === void 0 ? void 0 : utilityAllocation.utilityId,
            utilityType: fromHistory ? (_store$utilityProvide = store.utilityProviders.utilities.get(utility.utilityId)) === null || _store$utilityProvide === void 0 ? void 0 : _store$utilityProvide.utilityTypeName : utilityAllocation === null || utilityAllocation === void 0 ? void 0 : utilityAllocation.utilityType
          };
        })] : [];
        const statusObj = {};
        propUtilites.map(utility => {
          var _utility$allocation;
          const status = (_utility$allocation = utility.allocation) === null || _utility$allocation === void 0 ? void 0 : _utility$allocation.billStatus;
          if (!status) {
            if (!statusObj.Pending) {
              statusObj.Pending = [utility.utilityType];
              return;
            }
            statusObj.Pending.push(utility.utilityType);
          } else if (!statusObj[status] && status) {
            statusObj[status] = [utility.utilityType];
          } else if (status) {
            statusObj[status].push(utility.utilityType);
          }
        });
        setCompletedSteps(completedSteps(statusObj));
        setStatuses(_objectSpread({}, statusObj));
        setPropertyUtilites([...propUtilites]);
        setIsFetched(true);
      }).finally(() => setIsLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);
  useEffect(() => {
    setCompletedSteps(0);
    setStatuses({});
    setPropertyUtilites([]);
    setIsOpen(false);
    setIsFetched(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBuilding]);
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.allocation
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.allocationTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, title), isFetched && /*#__PURE__*/React.createElement(AllocationProgressBar, {
    completedSteps: complSteps,
    totalSteps: propertyUtilites.length
  })), /*#__PURE__*/React.createElement(Button, {
    component: RouterLink,
    className: classes.openAllocationButton,
    disabled: utilities && !utilities.length,
    size: "small",
    to: "/allocation_tables?allocationCycleId=".concat(cycle.id, "&propertyId=").concat(selectedBuilding).concat(fromHistory ? '&fromHistory=true' : ''),
    variant: "contained",
    'custom-attribute': '117-allocation-progress-bills-progress'
  }, t('allocations.open_allocation_tables'))), /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isOpen
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "allocation-content",
    id: "allocation-header",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    }),
    onClick: () => {
      if (!isFetched) {
        setIsLoading(true);
      }
      setIsOpen(prevValue => !prevValue);
    },
    'custom-attribute': '44-bills-progress'
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('allocations.view_allocation_summary'))), /*#__PURE__*/React.createElement("div", {
    className: classes.utilityIcons,
    onClick: e => e.stopPropagation(),
    onKeyDown: e => e.stopPropagation(),
    role: "button",
    tabIndex: 0
  }, propertyUtilites.length && isFetched ? availables.map(status => /*#__PURE__*/React.createElement(AllocationCounter, {
    billStatus: status,
    key: uuid(),
    statementDate: moment(cycle === null || cycle === void 0 ? void 0 : cycle.statementDate).format('L'),
    status: statuses[status] || []
  })) : null))), /*#__PURE__*/React.createElement(AccordionDetails, null, !propertyUtilites.length && isFetched ? /*#__PURE__*/React.createElement("div", {
    className: classes.noUtilitiesHint
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "light"
  }, t('allocations.no_allocations_for_property'))) : /*#__PURE__*/React.createElement(AllocationProgressTable, {
    allocation: {
      utilities: propertyUtilites
    },
    noTotal: true
  })))));
}